import i18n from '@/i18n';
import { isValidDate } from '@/utils/handlers';
import { listContactInformations } from '@/config/var-common';
import { regexEmail } from '@/utils/regex';
import { validateAllField } from '@/utils/validate';

function getDateFromFullDate(fullDate) {
    let day = fullDate.split('-')[2];
    let month = fullDate.split('-')[1];
    let year = fullDate.split('-')[0];
    return isValidDate(day + '/' + month + '/' + year);
}
function handleValidateInformationBasic(
    newDataInitForm,
    configCampaignStartDateTime,
    configCampaignEndDateTime,
    configSecretariatStartDateTime,
    configSecretariatEndDateTime,
    configUrlPublishTimeFrom,
    configUrlPublishTimeTo,
    configReceiptExpirationStartDateTime,
    configReceiptExpirationEndDateTime,
    contactInformations,
    configTabBasic
) {
    let check = true;
    let {
        campaign_start_date,
        campaign_end_date,
        campaign_start_time,
        campaign_end_time,
        secretariat_start_date,
        secretariat_end_date,
        secretariat_start_time,
        secretariat_end_time,
        url_publish_time_from,
        url_publish_time_to,
        url_publish_time_from_time,
        url_publish_time_to_time,
        receipt_expiration_start_date,
        receipt_expiration_end_date,
        receipt_expiration_start_time,
        receipt_expiration_end_time,
        sponsor_informations
    } = newDataInitForm;

    check = validateAllField(configTabBasic);

    // Validate campaign
    if (campaign_start_date) {
        if (!getDateFromFullDate(campaign_start_date)) {
            check = false;
            configCampaignStartDateTime.error = true;
            configCampaignStartDateTime.errorDateTimeStartCampaign = i18n.t('validateField.incorrectFormat', {
                field: 'キャンペーン開始年月日'
            });
        }
    }

    if (campaign_end_date) {
        if (!getDateFromFullDate(campaign_end_date)) {
            check = false;
            configCampaignEndDateTime.error = true;
            configCampaignEndDateTime.errorDateTimeEndCampaign = i18n.t('validateField.incorrectFormat', {
                field: 'キャンペーン終了年月日'
            });
        }
    }

    if (campaign_start_date && campaign_end_date) {
        const startDateObj = new Date(campaign_start_date);
        const endDateObj = new Date(campaign_end_date);
        if (campaign_start_time && campaign_end_time) {
            let startDateTime = new Date(campaign_start_date + ' ' + campaign_start_time);
            let endDateTime = new Date(campaign_end_date + ' ' + campaign_end_time);
            if (startDateTime >= endDateTime) {
                check = false;
                configCampaignStartDateTime.error = true;
                configCampaignStartDateTime.errorDateTimeStartCampaign = '事務局終了年月日の形式は正しくありません。';
            } else {
                configCampaignStartDateTime.error = false;
                configCampaignStartDateTime.errorDateTimeStartCampaign = '';
            }
        } else {
            if (startDateObj.getTime() >= endDateObj.getTime()) {
                check = false;
                configCampaignStartDateTime.error = true;
                configCampaignStartDateTime.errorDateTimeStartCampaign = '事務局終了年月日の形式は正しくありません。';
            }
        }
    }

    // Validate secretariat
    if (secretariat_start_date) {
        if (!getDateFromFullDate(secretariat_start_date)) {
            check = false;
            configSecretariatStartDateTime.error = true;
            configSecretariatStartDateTime.errorDateTimeStartSecretariat = i18n.t('validateField.incorrectFormat', {
                field: '事務局開始年月日'
            });
        }
    }

    if (secretariat_end_date) {
        if (!getDateFromFullDate(secretariat_end_date)) {
            check = false;
            configSecretariatEndDateTime.error = true;
            configSecretariatEndDateTime.errorDateTimeEndSecretariat = i18n.t('validateField.incorrectFormat', {
                field: '事務局終了年月日'
            });
        }
    }

    if (secretariat_start_date && secretariat_end_date) {
        const startDateObj = new Date(secretariat_start_date);
        const endDateObj = new Date(secretariat_end_date);

        if (secretariat_start_time && secretariat_end_time) {
            let startDateTime = new Date(secretariat_start_date + ' ' + secretariat_start_time);
            let endDateTime = new Date(secretariat_end_date + ' ' + secretariat_end_time);
            if (startDateTime >= endDateTime) {
                check = false;
                configSecretariatStartDateTime.error = true;
                configSecretariatStartDateTime.errorDateTimeStartSecretariat = '事務局終了年月日の形式は正しくありません。';
            } else {
                configSecretariatStartDateTime.error = false;
                configSecretariatStartDateTime.errorDateTimeStartSecretariat = '';
            }
        } else {
            if (startDateObj.getTime() >= endDateObj.getTime()) {
                check = false;
                configSecretariatStartDateTime.error = true;
                configSecretariatStartDateTime.errorDateTimeStartSecretariat = '事務局終了年月日の形式は正しくありません。';
            }
        }
    }

    // Validate url publish from
    if (url_publish_time_from) {
        if (!getDateFromFullDate(url_publish_time_from)) {
            check = false;
            configUrlPublishTimeFrom.error = true;
            configUrlPublishTimeFrom.errorText = i18n.t('validateField.incorrectFormat', {
                field: '公開期間'
            });
        }
    }

    // Validate url publish to
    if (url_publish_time_to) {
        if (!getDateFromFullDate(url_publish_time_to)) {
            check = false;
            configUrlPublishTimeTo.error = true;
            configUrlPublishTimeTo.errorText = i18n.t('validateField.incorrectFormat', {
                field: '公開期間'
            });
        }
    }

    if (url_publish_time_from && url_publish_time_to) {
        const startDateObj = new Date(url_publish_time_from);
        const endDateObj = new Date(url_publish_time_to);

        if (url_publish_time_from_time && url_publish_time_to_time) {
            let startDateTime = new Date(url_publish_time_from + ' ' + url_publish_time_from_time);
            let endDateTime = new Date(url_publish_time_to + ' ' + url_publish_time_to_time);
            if (startDateTime >= endDateTime) {
                check = false;
                configUrlPublishTimeFrom.error = true;
                configUrlPublishTimeFrom.errorText = '開始日は終了日以下である必要があります。';
            } else {
                configUrlPublishTimeFrom.error = false;
                configUrlPublishTimeFrom.errorText = '';
            }
        } else {
            if (startDateObj.getTime() >= endDateObj.getTime()) {
                check = false;
                configUrlPublishTimeFrom.error = true;
                configUrlPublishTimeFrom.errorText = '開始日は終了日以下である必要があります。';
            }
        }
    }

    // Validate receipt expiration date
    if (receipt_expiration_start_date) {
        if (!getDateFromFullDate(receipt_expiration_start_date)) {
            check = false;
            configReceiptExpirationStartDateTime.error = true;
            configReceiptExpirationStartDateTime.errorText = i18n.t('validateField.incorrectFormat', {
                field: 'レシート有効期限開始'
            });
        }
    }

    if (receipt_expiration_end_date) {
        if (!getDateFromFullDate(receipt_expiration_end_date)) {
            check = false;
            configReceiptExpirationEndDateTime.error = true;
            configReceiptExpirationEndDateTime.errorText = i18n.t('validateField.incorrectFormat', {
                field: 'レシート有効期限終了'
            });
        }
    }

    if (receipt_expiration_start_date && receipt_expiration_end_date) {
        const startDateObj = new Date(receipt_expiration_start_date);
        const endDateObj = new Date(receipt_expiration_end_date);
        if (receipt_expiration_start_time && receipt_expiration_end_time) {
            let startDateTime = new Date(receipt_expiration_start_date + ' ' + receipt_expiration_start_time);
            let endDateTime = new Date(receipt_expiration_end_date + ' ' + receipt_expiration_end_time);
            if (startDateTime >= endDateTime) {
                check = false;
                configReceiptExpirationStartDateTime.error = true;
                configReceiptExpirationStartDateTime.errorText = 'レシート有効期限開始の形式は正しくありません。';
            } else {
                configReceiptExpirationStartDateTime.error = false;
                configReceiptExpirationStartDateTime.errorText = '';
            }
        } else {
            if (startDateObj.getTime() >= endDateObj.getTime()) {
                check = false;
                configReceiptExpirationStartDateTime.error = true;
                configReceiptExpirationStartDateTime.errorText = 'レシート有効期限開始の形式は正しくありません。';
            }
        }
    }

    // Validate contact information
    listContactInformations.forEach((itemP) => {
        if (contactInformations && contactInformations[itemP.id]) {
            if (itemP.subText == 'メールアドレス') {
                if (contactInformations[itemP.id].length >= 255) {
                    check = false;
                    itemP.configInput.isEmail = false;
                    itemP.configInput.isMaxLength = true;
                    itemP.configInput.error = true;
                } else {
                    if (!regexEmail(contactInformations[itemP.id].trim())) {
                        itemP.configInput.isEmail = true;
                        itemP.configInput.error = true;
                        itemP.configInput.isMaxLength = false;
                        check = false;
                    }
                }
            }
        }

        if (itemP.child) {
            itemP.child.forEach((itemC) => {
                if (contactInformations && contactInformations[itemC.id] && contactInformations[itemC.id].length >= 255) {
                    check = false;
                    itemC.configInput.isMaxLength = true;
                    itemC.configInput.error = true;
                }
            });
        }
    });

    sponsor_informations.forEach((sponsor) => {
        if (sponsor?.note?.circulation_number) {
            if (sponsor.note.circulation_number.length > 255) {
                sponsor.note.configCirculationNumber.isMaxLength = true;
                sponsor.note.configCirculationNumber.error = true;
                check = false;
            } else {
                sponsor.note.configCirculationNumber.isMaxLength = false;
                sponsor.note.configCirculationNumber.error = false;
            }
        }
        if (sponsor?.note?.up_manufacturers) {
            if (sponsor.note.up_manufacturers.length > 255) {
                sponsor.note.configUpManufacturers.isMaxLength = true;
                sponsor.note.configUpManufacturers.error = true;
                check = false;
            } else {
                sponsor.note.configUpManufacturers.isMaxLength = false;
                sponsor.note.configUpManufacturers.error = false;
            }
        }
    });

    return check;
}

export { handleValidateInformationBasic };
